import { render } from "./ReportAI.vue?vue&type=template&id=524318ed&scoped=true"
import script from "./ReportAI.vue?vue&type=script&lang=js"
export * from "./ReportAI.vue?vue&type=script&lang=js"

import "./ReportAI.vue?vue&type=style&index=0&id=524318ed&scoped=true&lang=css"

import exportComponent from "/root/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-524318ed"]])

export default __exports__